import { useCallback, useState } from 'react';

/** Whether the desktop sidebar is hidden; remembered per browser (a viewer convenience only). */
export const SIDEBAR_STORAGE_KEY = 'crm-sidebar';

function readCollapsed(): boolean {
  try {
    return window.localStorage.getItem(SIDEBAR_STORAGE_KEY) === 'collapsed';
  } catch {
    return false; // Storage can be blocked (private mode): start with the sidebar open.
  }
}

function writeCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(SIDEBAR_STORAGE_KEY, collapsed ? 'collapsed' : 'open');
  } catch {
    // Not remembered, but the toggle still works for this visit.
  }
}

export function useSidebar(): { collapsed: boolean; toggle: () => void } {
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const toggle = useCallback(() => {
    setCollapsed((current) => {
      writeCollapsed(!current);
      return !current;
    });
  }, []);
  return { collapsed, toggle };
}
